import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    marginLeft: theme.spacing(1.5),
  },
  block: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  acceptancesBox: {
    cursor: 'pointer',
  },
  acceptancesTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  acceptancesPreviousText: {
    marginBottom: 4,
    fontSize: 14,
  },
  acceptancesText: {
    fontWeight: 300,
    fontSize: 12,
  },
  acceptancesTextScroll: {
    fontWeight: 300,
    fontSize: 12,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: 1.5,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
 
  acceptancesSeeMore: {
    fontWeight: 300,
    fontSize: 12,
    color: theme.palette.neutral.main,
  },
}))

export default useStyles
